import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';
import { getActiveTenantId } from '@/lib/tenant';
import type { UsageResponse } from '@/lib/api/types';

export function useUsage() {
  return useQuery({
    queryKey: ['billing', 'usage', getActiveTenantId()],
    queryFn: () => apiFetch<UsageResponse>('/billing/usage'),
  });
}
